module.exports = __webpack_public_path__ + "static/media/imperial_logo.a89a28b5.png";